import folderApi from '../../api/employee/folder'
import {ACTION} from '../../utils/constant'

export const state = () => ({
  folders: [],
  detailFolder: {},
  metadata: {},
  detailFile: {},
  errorFile: {},
  logFiles: {},
  listTags: [],
  listAuthor: [],
  listFolderSearch: [],
  metadataFolderSearch: {},
  loading: true
})

export const getters = {

}

export const mutations = {
  CHANGE_FOLDER_NULL (state) {
    state.folders = []
  },
  CHANGE_FOLDERS (state, slug) {
    state.folders = []
    if (slug.folders && !slug.files) {
      state.folders = [ ...slug.folders ]
    } else if (slug.files && !slug.folders) {
      state.folders = [ ...slug.files ]
    } else if (slug.files && slug.folders) {
      state.folders = [ ...slug.folders, ...slug.files ]
    } else {
      state.folders = []
    }
  },
  CHANGE_METADATA (state, slug) {
    state.metadata = { ...slug }
  },
  CHANGE_LIST_FOLDER_SEARCH (state, slug) {
    state.listFolderSearch = [...slug]
  },
  CHANGE_METADATA_FOLDER_SEARCH (state, slug) {
    state.metadataFolderSearch = {...slug}
  },
  CHANGE_DETAIL_FOLDER (state, slug) {
    state.detailFolder = { ...slug }
  },
  CHANGE_DETAIL_FILE (state, slug) {
    state.detailFile = { ...slug }
  },
  CHANGE_UPDATE_FOLDER (state, slug) {
    if (state.folders) {
      const tmpFolder = [...state.folders]
      const index = tmpFolder.findIndex(u => u.id === slug.id)
      Object.assign(tmpFolder[index], { ...slug })
      state.folders = tmpFolder
    }
  },
  CHANGE_ERROR_FILE (state, slug) {
    state.errorFile = { ...slug }
  },
  CHANGE_LOG_FILE (state, slug) {
    state.logFiles = { ...slug }
  },
  CHANGE_LIST_TAG (state, slug) {
    state.listTags = [...slug]
  },
  CHANGE_FOLDER_SEARCH (state, slug) {
    if (slug.page_index !== 1) {
      state.folders = [...state.folders, ...slug.data]
    } else {
      state.folders = []
      state.folders = [...slug.data]
    }
  },
  CHANGE_AUTHOR (state, slug) {
    state.listAuthor = [...slug]
  },
  CHANGE_LOADING (state, slug) {
    state.loading = slug
  }
}

export const actions = {
  async getFolder ({commit}, params) {
    commit('CHANGE_LOADING', true)
    try {
      if (params.page_index === 1) {
        commit('CHANGE_FOLDER_NULL')
      }
      const res = await folderApi.getFolder(params)
      if (res.status === 200) {
        commit('CHANGE_METADATA', res.data.metadata)
        commit('CHANGE_FOLDERS', {folders: res.data.data.folders, files: res.data.data.attachment_files, page_index: params.page_index})
      }
      commit('CHANGE_LOADING', false)
    } catch (error) {
    }
  },
  async detailFolder ({commit}, params) {
    try {
      const res = await folderApi.detailFolder(params)
      if (res.status === 200) {
        commit('CHANGE_DETAIL_FOLDER', res.data.data)
      }
    } catch (error) {

    }
  },
  async activeFile ({commit}, params) {
    try {
      const res = await folderApi.activeFile(params)
      if (res.status === 201) {
        if (params.action_type === ACTION.ACTION_TYPE_LOG_LIKED || params.action_type === ACTION.ACTION_TYPE_LOG_LIKE_REMOVED) {
          commit('CHANGE_UPDATE_FOLDER', res.data.data)
        }
      }
    } catch (error) {
    }
  },
  async getDetailFile ({commit}, params) {
    try {
      const res = await folderApi.getDetailFile(params)
      if (res.status === 200) {
        commit('CHANGE_DETAIL_FILE', res.data.data)
      }
    } catch (error) {
    }
  },
  async getTag ({commit}, params) {
    try {
      const res = await folderApi.getTags(params)
      if (res.status === 200) {
        commit('CHANGE_LIST_TAG', res.data.data)
      }
    } catch (error) {
    }
  },
  async getAuthor ({commit}, params) {
    try {
      const res = await folderApi.getAuthor(params)
      if (res.status === 200) {
        commit('CHANGE_AUTHOR', res.data.data)
      }
    } catch (error) {

    }
  },
  async getFolderBranches ({commit}, params) {
    try {
      const res = await folderApi.getFolderBranches(params)
      if (res.status === 200) {
        commit('CHANGE_LIST_FOLDER_SEARCH', res.data.data)
        commit('CHANGE_METADATA_FOLDER_SEARCH', res.data.metadata)
      }
    } catch (error) {
    }
  },
  async searchFile ({commit}, params) {
    commit('CHANGE_LOADING', true)
    try {
      if (params.page_index === 1) {
        commit('CHANGE_FOLDER_NULL')
      }
      const res = await folderApi.searchFile(params)
      if (res.status === 200) {
        commit('CHANGE_METADATA', res.data.metadata)
        commit('CHANGE_FOLDER_SEARCH', {data: res.data.data, page_index: params.page_index})
      }
      commit('CHANGE_LOADING', false)
    } catch (error) {
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/employee/folder.js